'use client';

import { Users, Handshake } from 'lucide-react';

export function PersonaBand() {
  return (
    <section className="bg-muted/20 py-3 border-y">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm">
          {/* Made for segment */}
          <div className="flex items-center gap-2 text-center sm:text-left">
            <Users className="w-4 h-4 text-primary flex-shrink-0" />
            <span className="font-medium">
              Made for:{' '}
              <span className="font-normal text-muted-foreground">
                Quality Managers, Lab/Metrology Leads, Ops Managers in ISO-driven manufacturing
              </span>
            </span>
          </div>

          {/* Separator */}
          <div className="hidden sm:block w-px h-6 bg-border" />

          {/* Works with segment */}
          <div className="flex items-center gap-2 text-center sm:text-left">
            <Handshake className="w-4 h-4 text-primary flex-shrink-0" />
            <span className="font-medium">
              Works with:{' '}
              <span className="font-normal text-muted-foreground">
                any calibration provider—upload/attach certs from multiple labs/vendors
              </span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

